import { all, fork } from "redux-saga/effects";

// Admin sagas — the only active sagas for the DrJobs admin panel
import adminAuthSaga from "./adminAuthSaga";
import adminDashboardSaga from "./adminDashboardSaga";
import adminCompaniesSaga from "./adminCompaniesSaga";
import adminAnalyticsSaga from "./adminAnalyticsSaga";
import adminJobsSaga from "./adminJobsSaga";
import adminUsersSaga from "./adminUsersSaga";
import adminSupportSaga from "./adminSupportSaga";
import adminSettingsSaga from "./adminSettingsSaga";
import adminWhatsAppSaga from "./adminWhatsAppSaga";
import adminCreditsSaga from "./adminCreditsSaga";
import adminSignalHireSaga from "./adminSignalHireSaga";

export function* sagas() {
  yield all([
    fork(adminAuthSaga),
    fork(adminDashboardSaga),
    fork(adminCompaniesSaga),
    fork(adminAnalyticsSaga),
    fork(adminJobsSaga),
    fork(adminUsersSaga),
    fork(adminSupportSaga),
    fork(adminSettingsSaga),
    fork(adminWhatsAppSaga),
    fork(adminCreditsSaga),
    fork(adminSignalHireSaga),
  ]);
}
